import { render, staticRenderFns } from "./EditFreeClinic.vue?vue&type=template&id=973a4ea0&scoped=true&"
import script from "./EditFreeClinic.vue?vue&type=script&lang=js&"
export * from "./EditFreeClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "973a4ea0",
  null
  
)

export default component.exports